<template>
  <div>
    <b-list-group flush>
      <b-list-group-item
        v-for="cp in comp"
        :key="cp.companyId"
      >
        <CompanyInput
          :edit="true"
          :is-read-only="ReadOnly"
          :company="cp"
          :IsDeleteAble="IsDeleteAble"
          @handle-del-btn="onDeleteBtnClicked"
          @handle-value-selected="onCompanySelected"
        />

      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import {
  BRow, BCol, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import CompanyInput from './CompanyInput.vue'

export default {
  components: {
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    CompanyInput,
  },
  props: {
    company: {
      type: Array,
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
    ReadOnly: String,
  },
  setup(props) {
    return {
      comp: props.company,
      isEdit: props.edit,
      selected: props.company[0].companyDetail,
      // ReadOnly: props.IsReadOnly,
    }
  },
  methods: {
    onCompanySelected(id, detail) {
      this.$emit('handleDetail', id, detail)
    },
    onDeleteBtnClicked(id) {
      this.$emit('handleDeleteBtn', id)
    },
  },
  computed: {
    IsDeleteAble: function () {
      //console.log('this.comp.length', this.comp.length)
      return this.comp.length <= 1 ? false : true
    },
}
}

</script>

 <style lang="scss" >

</style>
